export default "__VITE_ASSET__D6eCq_A1__"